import ShortAnswerQuestionType from "./question-authoring/short-answer";
import LongAnswerQuestionType from "./question-authoring/long-answer";
import MultipleChoiceQuestionType from "./question-authoring/multiple-choice";
import MultipleAnswerQuestionType from "./question-authoring/multiple-answer";
import DropdownQuestionType from "./question-authoring/dropdown";
import RatingQuestionType from "./question-authoring/rating";
import ScaleQuestionType from "./question-authoring/scale";
import NumberQuestionType from "./question-authoring/number";
import DateQuestionType from "./question-authoring/date";
import TimeQuestionType from "./question-authoring/time";
import DateTimeQuestionType from "./question-authoring/datetime";
import FileUploadQuestionType from "./question-authoring/file-upload";
import EmailQuestionType from "./question-authoring/email";
import PhoneQuestionType from "./question-authoring/phone";
import YesNoQuestionType from "./question-authoring/yes-no";
import MultipleChoiceGridQuestionType from "./question-authoring/multiple-choice-grid";
import CheckboxGridQuestionType from "./question-authoring/checkbox-grid";
import type { QuestionTypeRendererProps } from "./question-authoring/shared";

type SurveyQuestionTypeOptionsProps = QuestionTypeRendererProps;

export function SurveyQuestionTypeOptions({
  question,
  index,
  isPreview,
  optionErrorMessages,
  scaleLabelErrorMessage,
  dateRangeErrorMessage,
  yesNoLabelErrorMessage,
  onUpdateQuestion,
}: SurveyQuestionTypeOptionsProps) {
  const sharedProps = {
    index,
    isPreview,
    optionErrorMessages,
    scaleLabelErrorMessage,
    dateRangeErrorMessage,
    yesNoLabelErrorMessage,
    onUpdateQuestion,
  };

  switch (question.type) {
    case "short_answer":
      return (
        <ShortAnswerQuestionType
          question={question}
          {...sharedProps}
        />
      );
    case "long_answer":
      return (
        <LongAnswerQuestionType
          question={question}
          {...sharedProps}
        />
      );
    case "multiple_choice":
      return (
        <MultipleChoiceQuestionType
          question={question}
          {...sharedProps}
        />
      );
    case "multiple_answer":
      return (
        <MultipleAnswerQuestionType
          question={question}
          {...sharedProps}
        />
      );
    case "dropdown":
      return (
        <DropdownQuestionType
          question={question}
          {...sharedProps}
        />
      );
    case "rating":
      return (
        <RatingQuestionType
          question={question}
          {...sharedProps}
        />
      );
    case "scale":
      return (
        <ScaleQuestionType
          question={question}
          {...sharedProps}
        />
      );
    case "number":
      return (
        <NumberQuestionType
          question={question}
          {...sharedProps}
        />
      );
    case "date":
      return (
        <DateQuestionType
          question={question}
          {...sharedProps}
        />
      );
    case "time":
      return (
        <TimeQuestionType
          question={question}
          {...sharedProps}
        />
      );
    case "datetime":
      return (
        <DateTimeQuestionType
          question={question}
          {...sharedProps}
        />
      );
    case "file_upload":
      return (
        <FileUploadQuestionType
          question={question}
          {...sharedProps}
        />
      );
    case "email":
      return (
        <EmailQuestionType
          question={question}
          {...sharedProps}
        />
      );
    case "phone":
      return (
        <PhoneQuestionType
          question={question}
          {...sharedProps}
        />
      );
    case "yes_no":
      return (
        <YesNoQuestionType
          question={question}
          {...sharedProps}
        />
      );
    case "multiple_choice_grid":
      return (
        <MultipleChoiceGridQuestionType
          question={question}
          {...sharedProps}
        />
      );
    case "checkbox_grid":
      return (
        <CheckboxGridQuestionType
          question={question}
          {...sharedProps}
        />
      );
  }
}

export default SurveyQuestionTypeOptions;
